
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[name]",
      function () {
        return require("private-next-pages/product/[name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[name]"])
      });
    }
  